import React, { useState, useEffect, useRef } from 'react';
import { svg } from '../assets/svg/common.js'
import { useDispatch, useSelector } from "react-redux";
import { Tooltip } from 'antd';
import { convertToLocal } from '../helper/commonHelper.js'
import { deleteEmails, updateEmails } from '../helper/emailHelper.js';
import { decrypt } from '../helper/apiHelper.js'
import db from '../helper/dbHelper.js';
import { useLoading } from '../context/LoadingContext';
import { downloadFile, getFile, getFileIcon } from '../helper/attachmentHelper.js';
import { FileReaderModel } from '../components/modals/common-alert.js';
import { toast, Bounce } from 'react-toastify';
import Swal from 'sweetalert2';
import { getGeneralSettings } from '../helper/apiHelper.js'
import Event from './Event.js';
import { Button, Popover } from 'antd';
import { CaretDownOutlined } from '@ant-design/icons';
import moment from "moment-timezone";

function MessageBox(props) {
    const [selectedMessage, setSelectedMessages] = useState(null);
    const [heightToEnd, setHeightToEnd] = useState(0);
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const [decryptFile, setDecryptFile] = useState(null);
    const [isOpenFileReader, setIsOpenFileReader] = useState(false);
    const [icons, setIcons] = useState({});
    const messageSectionRef = useRef(null);
    const { showLoader, hideLoader } = useLoading();
    const dispatch = useDispatch();
    const isCompose = useSelector((state) => state.isCompose);

    const calculateHeight = () => {
        if (messageSectionRef.current) {
            const messageSectionTop = messageSectionRef.current.getBoundingClientRect().top;
            const heightToEnd = window.innerHeight - messageSectionTop;
            setHeightToEnd(heightToEnd - 100);
        }
    };

    useEffect(() => {
        setSelectedMessages(props.message);
        const updateHeight = () => {
            setTimeout(() => calculateHeight(), 100);
        };
        updateHeight();
        window.addEventListener('resize', updateHeight);

        return () => {
            window.removeEventListener('resize', updateHeight);
        };
    }, [props.message]);

    useEffect(() => {
        const fetchIcons = async () => {
            const newIcons = {};
            if (selectedMessage && selectedMessage.decryptedData && Array.isArray(selectedMessage.decryptedData.attachment) && selectedMessage.decryptedData.attachment.length) {
                for (const attachment of selectedMessage.decryptedData.attachment) {
                    const type = Object.keys(attachment)[0];
                    const icon = await getFileIcon(type);
                    newIcons[type] = icon;
                }
            }
            setIcons(newIcons);
        };
        fetchIcons();
    }, [selectedMessage]);


    const decryptMessage = async (message) => {
        try {
            showLoader()
            const user = JSON.parse(localStorage.getItem('user'));
            const data = await decrypt(user.wallet.wallet.privateKey, message.encryptedData);
            if (data.returnValue) {
                const returnValue = JSON.parse(data.returnValue);
                const existingMail = await db.inbox.where("mailId").equals(message.id).toArray();
                const decryptedObject = { mailId: message.id, decryptedMail: returnValue };
                if (existingMail.length) {
                    await db.inbox.update(existingMail[0].id, decryptedObject);
                } else {
                    await db.table(props.pageType).add(decryptedObject);
                }
                if (!message.isRead) {
                    await updateEmails('isRead', [message.id]);
                }
                setSelectedMessages({ ...message, decryptedData: returnValue });
                props.setSelectedMgs({ ...message, decryptedData: returnValue });
                props.reRender();
            }
        }
        catch (err) {
            console.error(err)
        }
        finally {
            hideLoader()
        }
    }

    const replyMeaage = async (type) => {
        if (!selectedMessage.decryptedData) {
            toast.warning("Please decrypt the message.", {
                position: "top-center",
                transition: Bounce,
            });
            return;
        }
        if (!isCompose) {
            const emailDetails = JSON.parse(selectedMessage.emailDetails);
            const getSender = props.pageType !== 'sent' ? emailDetails.sender : getName(selectedMessage.emailDetails);
            const reSubject = selectedMessage.subject.startsWith('Re') ? selectedMessage.subject : `Re: ${selectedMessage.subject}`;
            const fwSubject = selectedMessage.subject.startsWith('Fw') ? selectedMessage.subject : `Fw: ${selectedMessage.subject}`;
            let message = '';
            const response = await getGeneralSettings();
            if (response) {
                if (response.is_previous_msg) {
                    message = `<div>
                    <p><br></p> 
                    <p><br>---------------------------------------------------------------------</p>
                    <p>On ${convertToLocal(selectedMessage.created_at)}, ${getSender} wrote:</p> 
                    <blockquote>${selectedMessage.decryptedData.message}</blockquote>
                    <p></p>
                  </div>`;
                } else {
                    message = '';
                }
            } else {
                message = `<div>
                <p><br></p> 
                <p><br>---------------------------------------------------------------------</p>
                <p>On ${convertToLocal(selectedMessage.created_at)}, ${getSender} wrote:</p> 
                <blockquote>${selectedMessage.decryptedData.message}</blockquote>
                <p></p>
              </div>`;
            }

            if (type === 'Reply') {
                localStorage.setItem('recipient', getSender);
                localStorage.removeItem('cc');
                localStorage.removeItem('bcc');
                localStorage.setItem('subject', reSubject);
                localStorage.setItem('message', message);
                dispatch({ type: "IS_COMPOSE", payload: true });
            } else {
                localStorage.removeItem('recipient');
                localStorage.removeItem('cc');
                localStorage.removeItem('bcc');
                localStorage.setItem('subject', fwSubject);
                localStorage.setItem('message', message);
                dispatch({ type: "IS_COMPOSE", payload: true });
            }

        }
    }

    const deleteMessage = async () => {
        Swal.fire({
            text: "Are you sure you want to delete?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#1677ff",
            cancelButtonColor: "#ffffff",
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            customClass: "compose-sweet-alert"
        }).then(async (result) => {
            if (result.isConfirmed) {
                showLoader();
                await deleteEmails(props.pageType, [selectedMessage.id]);
                props.setSelectedMgs(null);
                setSelectedMessages(null);
                props.reRender();
                hideLoader();
            }
        });

    }

    const favAction = async () => {
        showLoader();
        await updateEmails('fav', [selectedMessage.id]);
        props.reRender();
        hideLoader();
    }
    const renderTime = (time) => {
        const formattedDate = moment.tz(time, moment.tz.guess()).format('ddd MMM DD YYYY hh:mm A');
        return formattedDate;
    }
    const content = (message) => {
        return <div>
            <div>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                        <tr>
                            <th style={{ textAlign: "left", paddingRight: "10px", display: "flex", alignItems: 'start', justifyContent: "end" }}>from:</th>
                            <td>{message?.sender}</td>
                        </tr>
                        <tr>
                            {message?.toValue && <>
                                <th style={{ textAlign: "left", paddingRight: "10px", display: "flex", alignItems: 'start', justifyContent: "end" }}>to:</th>
                                <td>
                                    <ul style={{ paddingLeft: "0", marginBottom: "5px" }}>
                                        {message?.toValue?.map((data, index) => (
                                            <li key={index} style={{ listStyle: "none" }}>
                                                {data}
                                            </li>
                                        ))}
                                    </ul>
                                </td>
                            </>}

                        </tr>
                        <tr>
                            {message.subject && <>
                                <th style={{ textAlign: "left", paddingRight: "10px", display: "flex", alignItems: 'start', justifyContent: "end" }}>subject:</th>
                                <td style={{ width: "300px", wordBreak: "break-word" }}>{message.subject}</td>
                            </>}
                        </tr>
                        {message?.ccValue?.length > 0 && <tr>
                            <th style={{ textAlign: "left", paddingRight: "10px", display: "flex", alignItems: 'start', justifyContent: "end" }}>cc:</th>
                            <td>
                                <ul style={{ paddingLeft: "0", marginBottom: "5px" }}>
                                    {message?.ccValue?.map((data, index) => (
                                        <li key={index} style={{ listStyle: "none" }}>
                                            {data}
                                        </li>
                                    ))}
                                </ul>
                            </td>
                        </tr>}
                        {message?.bccValue?.length > 0 && <tr>
                            <th style={{ textAlign: "left", paddingRight: "10px", display: "flex", alignItems: 'start', justifyContent: "end" }}>bcc:</th>
                            <td>
                                <ul style={{ paddingLeft: "0", marginBottom: "5px" }}>
                                    {message?.bcc.map((data, index) => (
                                        <li key={index} style={{ listStyle: "none" }}>
                                            {data}
                                        </li>
                                    ))}
                                </ul>
                            </td>
                        </tr>}
                        <tr>
                            <th style={{ textAlign: "left", paddingRight: "10px", justifyContent: "end", display: "flex" }}>date:</th>
                            <td>{renderTime(message.receivedDate)}</td>
                        </tr>
                        <tr>
                            <th style={{ textAlign: "left", paddingRight: "10px", justifyContent: "end", display: "flex" }}>mailed-by:</th>
                            <td>{message.sender.split("@")[1]}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    }
  const template = (message,data)=>{
    return (
        <div className='senderDetails'>
            <p style={{ marginBottom: 0, marginRight: "5px" }}>{data}</p>
            {message.toValue?.length > 0 && data !== "to me"&&
                message.toValue.map((email, index) => {
                    const name = email.split("@")[0];
                    const isLast = index === message.toValue.length - 1;

                    return (
                        <React.Fragment key={index}>
                            <span className='senderValue'>
                                {name}
                                {!isLast && ", "}
                            </span>
                        </React.Fragment>
                    );
                })}
            <div className='mailDetails'>
                <Popover content={content(message)} placement="bottom">
                    <Button style={{ padding: 0, border: 0 }}>
                        <CaretDownOutlined />
                    </Button>
                </Popover>
            </div>
        </div>
    );
  }
    const getName = (emailDetails) => {
        const data = JSON.parse(emailDetails);

        const ccValue = data?.cc
            ? data.cc.split(",").map(item => item.trim()).filter(Boolean)
            : [];

        const bccValue = data?.bcc
            ? data?.bcc?.split(",").map(item => item.trim()).filter(Boolean)
            : [];

        const toValue = data?.to
            ? data?.to?.split(",").map(item => item.trim()).filter(Boolean)
            : [];

        const message = {
            ...selectedMessage,
            ccValue,
            bccValue,
            toValue,
        };
      const responseValue = template(message,"to")
     return responseValue
       
    };

    const getSenderOrRecipientName = (selectedMessage) => {
        const name = !selectedMessage.isSent
            ? selectedMessage.sender
            : JSON.parse(selectedMessage.emailDetails).to;

        return name.split('@')[0];
    };
    const senderDetail = (value)=>{
         const response  = JSON.parse(value)
        const message = {
            ...response,
            ccValue:response?.cc,
            bccValue:response?.bcc,
            toValue:response?.to,
        };
      const responseValue =  template(message,"to me")
      return responseValue;
    }
    return (
        <>
            <div className="col-lg-9 col-md-8 col-sm-6 col-4">
                {selectedMessage &&
                    <div className='message-box-section'>
                        <div className="message-box-header d-flex justify-content-between">
                            <div className='message-subject'><h4>{selectedMessage.subject}</h4></div>
                            <div className='message-box-tools d-flex gap-3'>
                                <Tooltip title="Starred"><span className='cursor-pointer' onClick={async () => {
                                    await favAction();
                                }}>{selectedMessage.isStarred ? svg.fav : svg.star}</span></Tooltip>
                                <Tooltip title="Reply"><span className='cursor-pointer' onClick={async () => {
                                    await replyMeaage('Reply');
                                }}>{svg.reply}</span></Tooltip>
                                <Tooltip title="Forward"><span className='cursor-pointer' onClick={async () => {
                                    await replyMeaage('Forward');
                                }}>{svg.farward}</span></Tooltip>
                                <Tooltip title="Delete"><span className='cursor-pointer' onClick={async () => {
                                    await deleteMessage();
                                }}>{svg.delete}</span></Tooltip>
                                <Tooltip title="Menu"><span className='cursor-pointer'>{svg.menu}</span></Tooltip>
                            </div>
                        </div>
                        <div className='msg-box-body d-flex mt-3'>
                            <div className='msg-body-user'>
                                <div className="profile-pic cursor-pointer">{getSenderOrRecipientName(selectedMessage).charAt(0).toUpperCase() || '#'}</div>
                            </div>
                            <div className='msg-body-contents'>
                                <div className='d-flex justify-content-between'>
                                    <div className='ps-2'>
                                        <span className="msg-name">{getSenderOrRecipientName(selectedMessage)}</span>
                                        <div className="msg-time">{!selectedMessage.isSent ? senderDetail(selectedMessage.emailDetails) : getName(selectedMessage.emailDetails)}</div>
                                    </div>
                                    <div className="msg-time">{convertToLocal(selectedMessage.created_at)}</div>
                                </div>
                                <div className='msg-messages ps-2 mt-5 text-justify-custom' ref={messageSectionRef} style={{ height: `${heightToEnd}px` }}>
                                    {!selectedMessage.decryptedData &&
                                        <div className='encrypted-msg-section'>
                                            <div className="encrypted-heading"> Encrypted content! </div>
                                            <span className='text-break'>{selectedMessage?.encryptedData?.slice(0, 1000)}...</span>
                                            <button className='decrypt-btn' onClick={() => { decryptMessage(selectedMessage) }}>{svg.lock} Decrypt Message</button>
                                        </div>
                                    }

                                    {selectedMessage.decryptedData && selectedMessage.decryptedData.message &&
                                        <div className='decrypted-msg-section container-fluid'>
                                            {selectedMessage.decryptedData.event &&
                                                <Event event={selectedMessage.decryptedData.event} />
                                            }
                                            <span dangerouslySetInnerHTML={{ __html: selectedMessage.decryptedData.message }}></span>
                                        </div>
                                    }

                                    {selectedMessage &&
                                        selectedMessage.decryptedData &&
                                        Array.isArray(selectedMessage.decryptedData.attachment) &&
                                        selectedMessage.decryptedData.attachment.length > 0 && (
                                            <div className="attachment-msg-section mt-5 pb-2">
                                                {selectedMessage.decryptedData.attachment.map((attachment, index) => (
                                                    <div
                                                        className="attachment-div-element d-flex-data"
                                                        key={index}
                                                        onMouseEnter={() => setHoveredIndex(index)}
                                                        onMouseLeave={() => setHoveredIndex(null)}
                                                        onClick={async () => {
                                                            try {
                                                                showLoader();
                                                                const decryptedFile = await getFile(
                                                                    Object.keys(attachment)[0],
                                                                    attachment[Object.keys(attachment)[0]]
                                                                );
                                                                setDecryptFile(decryptedFile);
                                                                setIsOpenFileReader(true);
                                                            } catch (e) {
                                                                console.error('Error getting file:', e);
                                                            } finally {
                                                                hideLoader();
                                                            }
                                                        }}
                                                    >
                                                        <span className="text-truncate file-name-preview">
                                                            {Object.keys(attachment)[0]}
                                                        </span>
                                                        {hoveredIndex !== index ? (
                                                            <div className="attachment-icon">
                                                                {icons[Object.keys(attachment)[0]] || ''}
                                                            </div>
                                                        ) : (
                                                            <div className="attachment-actions">
                                                                <Tooltip title="Download">
                                                                    <div
                                                                        onClick={async (e) => {
                                                                            e.stopPropagation();
                                                                            try {
                                                                                showLoader();
                                                                                await downloadFile(
                                                                                    Object.keys(attachment)[0],
                                                                                    attachment[Object.keys(attachment)[0]]
                                                                                );
                                                                            } catch (err) {
                                                                                console.error('Error downloading file:', err);
                                                                            } finally {
                                                                                hideLoader();
                                                                            }
                                                                        }}
                                                                    >
                                                                        {svg.download_svg_attachment}
                                                                    </div>
                                                                </Tooltip>
                                                            </div>
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                        )}

                                </div>
                            </div>
                        </div>
                        {selectedMessage.decryptedData &&
                            <div className='msg-box-btns d-flex mt-5 gap-3'>
                                <button className='reply-btn' onClick={async () => {
                                    await replyMeaage('Reply');
                                }}>{svg.light_reply} Reply</button>
                                <button className='far-btn' onClick={async () => {
                                    await replyMeaage('Forward');
                                }}>{svg.blue_forward} Forward</button>
                            </div>
                        }
                    </div>
                }
                {isOpenFileReader &&
                    <FileReaderModel isOpen={isOpenFileReader} file={decryptFile} close={() => {
                        setDecryptFile(null)
                        setIsOpenFileReader(false)
                    }} />
                }
            </div>
        </>
    );
}

export default MessageBox;
